// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/season-stats-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamSeasonStatsGetBody,
  typeTeamSeasonStatsGetOutput200,
} from "../../sdk/team/postTeamSeasonStatsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamSeasonStatsGetQueryKey(
  payload: typeTeamSeasonStatsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  return [
    "post:team:teamSeasonStatsGet",
    "svc:sports-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeTeamSeasonStatsGetOutput200,
    unknown,
    typeTeamSeasonStatsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamSeasonStatsGet(
  payload: typeTeamSeasonStatsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamSeasonStatsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamSeasonStatsGet(payload),
    ...resolvedOptions,
  });
}
